<template>
  <div class="generic-html" :style="customStyle">
    <div v-if="html" v-html="html" :class="`html-${uuid}`" />
  </div>
</template>

<script>
import _ from 'lodash'
import {v4 as uuidv4} from 'uuid'

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      uuid: uuidv4()
    }
  },
  computed: {
    html() {
      return _.get(this.component, 'html', '')
    },
    customTagStyles() {
      return _.get(this.component, 'customTagStyles', {})
    },
    customStyle() {
      return _.get(this.component, 'props.style', {})
    },
  },
  mounted() {
    this.ApplyCustomTagStyles()
  },
  methods: {
    ApplyCustomTagStyles() {
      if (_.isEmpty(this.customTagStyles)) {
        return
      }

      Object.keys(this.customTagStyles).forEach((tag) => {
        const style = document.createElement('style')
        style.innerHTML = `
          .html-${this.uuid} ${tag} { ${this.customTagStyles[tag]} }
        `

        this.$el.appendChild(style)
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.generic-html {
  &::v-deep img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
  }
}
</style>
